import PropTypes from 'prop-types'

import AuthLayout from '../../layouts/AuthLayout'
import RouteBranch from '../RouteBranch'

const AuthBranch = ({ routes, ...props }) => {
  return (
    <AuthLayout>
      {routes.map(({ path, ...route }) => (
        <RouteBranch key={path} path={path} {...props} {...route} />
      ))}
    </AuthLayout>
  )
}

AuthBranch.propTypes = {
  routes: PropTypes.array,
}

export default AuthBranch
